import { compose } from 'redux'

import APPLICATION_SETTINGS from 'src/config/settings'

import { getTokenFromStorage } from './getTokenFromStorage'

export const getRefreshTokenKey = () => {
  const ownerId = APPLICATION_SETTINGS.appIdentifier.ownerId
  return `_hp_mbe_${ownerId}_refresh_token`
}

export const getRefreshToken = () => {
  return compose(getTokenFromStorage, getRefreshTokenKey)()
}
